/*
 * 订单数据--订单故障停止原因Top10--故障原因产生的订单
 */
import React, { Component } from "react";
import PropTypes from "prop-types";
import ScGridTable from "@/components/display/table/gridTableCore";
import { queryOrderCountDetail } from "@/fetch/fetchApi";

class AbnormalOrder extends Component {
  state = {
    tableConfig: null,
  };

  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  componentWillMount() {
    // console.log("AbnormalOrder componentWillMount", this.props);
    const modalParam = this.context.store.getState().modalInfo.param;
    this.setState({
      tableConfig: {
        tableKey: "abnormalOrderTable",
        tableColumns: [
          {
            name: "设备编号",
            key: "stubId",
            colType: "textCol",
            align: "center",
          },
          {
            name: "场站名称",
            key: "stubGroupName",
            colType: "textCol",
            align: "center",
          },
          {
            name: "订单编号",
            key: "orderId",
            colType: "textCol",
            align: "center",
          },
        ],
        tableChange: () => {},
        tableParam: {
          pagecount: 10,
          ...modalParam,
        },
        dataApi: queryOrderCountDetail,
        autoRefresh: true, // 设置为true 直接加载grid数据
      },
    });
  }

  render() {
    return <ScGridTable config={this.state.tableConfig} />;
  }
}

export default AbnormalOrder;



// WEBPACK FOOTER //
// ./src/AntD/pages/indicatorReport/chargeSuccessRate/detail/abnormalOrder.js